/**
 * Pastille d'identité d'une macro.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * 🔴 CE QUI RESTE DE CE FICHIER, ET POURQUOI
 * ══════════════════════════════════════════════════════════════════════════
 *
 * Il portait aussi `MacroBar` et `MacroChip`, les jauges de l'ancien système.
 * La refonte « Nourri » les remplace par `components/nourri/ProgressBar`, et
 * elles ont été **supprimées** le 26/08/2026 plutôt que laissées à rouiller :
 * une bibliothèque qui expose deux façons de dessiner la même jauge finit par
 * en voir apparaître une troisième.
 *
 * `MacroDot` survit parce que la refonte n'a pas d'équivalent — la pastille de
 * `nourri-screens.css` (`.n-dot`) est une classe, pas un composant, et quatre
 * écrans ont besoin de la poser depuis du TypeScript, à côté d'un libellé
 * calculé.
 *
 * 🔴 **La couleur est un repère SECONDAIRE, jamais le seul.** Chaque pastille
 * est collée à un libellé texte (« Prot. », « Gluc. »…), et cette condition
 * n'est pas facultative : en protanopie, deux teintes de macro peuvent se
 * rapprocher au point de ne plus se distinguer. C'est le mot qui départage.
 */

import { MACRO_COLORS } from './tokens';
import type { MacroKey } from '../../lib/macros';

/**
 * Pastille de 8 px — l'identité d'une macro, à côté de son nom.
 *
 * ⚠️ `aria-hidden` : elle ne dit rien qu'un lecteur d'écran doive entendre. Le
 * libellé, lui, est déjà là.
 */
export function MacroDot({ macro }: { macro: MacroKey }) {
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        background: MACRO_COLORS[macro],
        marginRight: '0.3rem',
        flexShrink: 0,
      }}
    />
  );
}
